import { FC, PropsWithChildren } from 'react';
import { useEffectOnce } from 'react-use';
import {
  type UseAnalyticsPageParams,
  useAnalytics,
} from '../../hooks/useAnalytics/useAnalytics.hook';

type TrackPageViewProps = PropsWithChildren<UseAnalyticsPageParams>;

export const TrackPageView: FC<TrackPageViewProps> = ({
  children,
  category,
  name,
  properties = {},
}) => {
  const { page } = useAnalytics();

  useEffectOnce(() => {
    page({ category, name, properties });
  });

  return <>{children}</>;
};
